import React from 'react';
import { Link } from 'react-router-dom';

const MenuProductosItem = (props) => {
    return (
    <li>
       <Link to={"/" + props.codigo} activeClassName="active">
          {props.codigo}
       </Link>
     </li>
    );
}

export default MenuProductosItem;


// WEBPACK FOOTER //
// ./Portico/App/Screens/MenuProductos/components/MenuProductosItem.jsx